module.exports = __webpack_public_path__ + "static/media/Hugh L. White - 1836.e72d6d6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Hugh L. White - 1836.jpg
// module id = 495
// module chunks = 0